import React, { useEffect, useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { getEmployees } from "../data/redux/employee/employeeAction";
import { fetchAllIndicator } from "../data/redux/performance/indicator/indicatorAction";
import { fetchAllIndicatorGroup } from "../data/redux/performance/indicatorgroup/indicatorgroupAction";
import { fetchAllRoleindicator } from "../data/redux/performance/roleindicator/roleindicatorAction";
import {
  createSelfappraisal,
  updateAppraisal,
} from "../data/redux/performance/appraisal/appraisalAction";

interface selectedRow {
  selectedRow: any;
  edit: boolean;
}

const PerformanceAppraisalModal: React.FC<selectedRow> = ({
  selectedRow,
  edit,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { roleindicator } = useSelector((state: any) => state.performance.roleindicator);
  const { rating } = useSelector((state: any) => state.performance.rating);
  const { employees } = useSelector((state: any) => state.employee);


  

  const [formData, setFormData] = useState<any>({
    employee: "",
    appraisalDate: "",
    status: "",
    ratings: {},
    createdBy: user.UserId,
  });

  const statusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Done", label: "Done" },
  ];

  const [tabs, setTabs] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<number | null>(null);

  console.log(selectedRow, "selectedrow");
  console.log(edit, "edit");


  useEffect(() => {
    if (selectedRow?.Id) {
      setFormData({
        employee:
          employees
            .map((emp: any) => ({
              value: emp.EmployeeID,
              label: emp.Name,
            }))
            .find((emp: any) => emp.value === selectedRow.employeeId) || null,
        appraisalDate: selectedRow.AppraisalDate || "",
        status: selectedRow.Status || "",
        ratings: selectedRow.appraisalDetails.reduce(
          (acc: any, detail: any) => {
            acc[detail.groupId] = detail.indicators.reduce(
              (indAcc: any, ind: any) => {
                indAcc[ind.indicatorId] = { ratingId: ind.ratingId };
                return indAcc;
              },
              {}
            );
            return acc;
          },
          {}
        ),
      });
  
      // Set related role-based tabs for existing employee
      const selectedEmployee = employees.find(
        (emp: any) => emp.EmployeeID === selectedRow.employeeId
      );
  
      if (selectedEmployee) {
        const { DesignationId } = selectedEmployee;
  
        const matchingRoles = roleindicator.filter(
          (role: any) => Number(role.DesignationId) === Number(DesignationId)
        );
  
        const updatedRoleGroups = matchingRoles.map((role: any) => ({
          selectedGroup: { value: role.Id, label: role.Name },
          indicators: [
            {
              indicator_id: role.Id,
              indicator_name: role.Name,
              ratings:
                rating.length > 0
                  ? rating.map((r: any) => ({
                      id: r.Id,
                      rating_name: r.Name,
                    }))
                  : [],
            },
          ],
        }));
  
        const newTabs = updatedRoleGroups.map((group: any, index: number) => ({
          id: `${group.selectedGroup.value}-${index}`,
          name: group.selectedGroup.label,
          indicators: group.indicators,
        }));
  
        setTabs(newTabs);
        setActiveTab(newTabs.length > 0 ? newTabs[0].id : null);
      }
    }
  }, [selectedRow, employees, roleindicator, rating]);
  

  useEffect(() => {
    if (formData.employee) {
      handleEmployeeChange(formData.employee);
    }
  }, [formData.employee]);

  useEffect(() => {
    dispatch(getEmployees());
    dispatch(fetchAllIndicator());
    dispatch(fetchAllIndicatorGroup());
    dispatch(fetchAllRoleindicator());
  }, [dispatch]);

  const handleInputChange = (name: string, value: any) => {
    if (name === "appraisalDate" && value instanceof Date) {
      const formattedDate = value.toISOString().split("T")[0];
      setFormData((prev: any) => ({ ...prev, [name]: formattedDate }));
    } else {
      setFormData((prev: any) => ({ ...prev, [name]: value }));
    }
  };

  const handleStatusChange = (status: string) => {
    setFormData((prev: any) => ({ ...prev, status }));
  };

  const handleEmployeeChange = (selected: any) => {
    if (!selected) return;

    const selectedEmployee = employees.find(
      (emp: any) => emp.EmployeeID === selected.value
    );
    if (!selectedEmployee) return;

    const { DesignationId } = selectedEmployee;

    const matchingRoles = roleindicator.filter(
      (role: any) => Number(role.DesignationId) === Number(DesignationId)
    );

    const updatedRoleGroups = matchingRoles.map((role: any) => ({
      selectedGroup: { value: role.Id, label: role.Name },
      indicators: [
        {
          indicator_id: role.Id,
          indicator_name: role.Name,
          ratings:
            rating.length > 0
              ? rating.map((r: any) => ({
                  id: r.Id,
                  rating_name: r.Name,
                }))
              : [],
        },
      ],
    }));

    const newTabs = updatedRoleGroups.map((group: any, index: number) => ({
      id: `${group.selectedGroup.value}-${index}`,
      name: group.selectedGroup.label,
      indicators: group.indicators,
    }));

    setTabs(newTabs);
    setActiveTab(newTabs.length > 0 ? newTabs[0].id : null);

    setFormData((prev: any) => ({
      ...prev,
      employee: selected,
      role_groups: updatedRoleGroups,
    }));
  };

  const handleRatingChange = (
    tabId: string,
    indicatorId: number,
    selectedOption: any
  ) => {
    setFormData((prev: any) => {
      const updatedRatings = { ...prev.ratings };

      if (!updatedRatings[tabId]) {
        updatedRatings[tabId] = {};
      }

      updatedRatings[tabId][indicatorId] = {
        ratingId: selectedOption.value,
        ratingName: selectedOption.label,
      };

      return { ...prev, ratings: updatedRatings };
    });
  };

  const handleTabChange = (tabId: number) => {
    setActiveTab(tabId);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if(edit){

      if (!formData.employee || !formData.appraisalDate) {
        alert("Please fill in all required fields.");
        return;
      }
  

      const formattedData = {
        employeeId: formData.employee.value,
        appraisalDate: formData.appraisalDate,
        appraisalDetails: tabs.map((tab: any) => ({
          groupId: tab.id.split("-")[0],
          indicators: tab.indicators.map((indicator: any) => ({
            indicatorId: indicator.indicator_id,
            ratingId:
              formData.ratings?.[tab.id]?.[indicator.indicator_id]?.ratingId ||
              null,
          })),
        })),
        status: formData.status,
        createdBy: user.UserId,
      };
      let Appraisal = selectedRow.Id;
      dispatch(updateAppraisal({ Appraisal, data: formattedData }))
      .then((res) =>{
        if (res.meta.requestStatus === "fulfilled") {
          alert(res.payload.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          alert(res.payload.message);
        }
      })
    }else{
      if (!formData.employee || !formData.appraisalDate) {
        alert("Please fill in all required fields.");
        return;
      }
  
      const formattedData = {
        employeeId: formData.employee.value,
        appraisalDate: formData.appraisalDate,
        appraisalDetails: tabs.map((tab: any) => ({
          groupId: tab.id.split("-")[0],
          indicators: tab.indicators.map((indicator: any) => ({
            indicatorId: indicator.indicator_id,
            ratingId:
              formData.ratings?.[tab.id]?.[indicator.indicator_id]?.ratingId ||
              null,
          })),
        })),
        status: formData.status,
        createdBy: user.UserId,
      };
  
      dispatch(createSelfappraisal(formattedData)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          alert(res.payload.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          alert(res.payload.message);
        }
      });
    }
    
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (!formData.employee || !formData.appraisalDate) {
  //     alert("Please fill in all required fields.");
  //     return;
  //   }

  //   const formattedData = {
  //     employeeId: formData.employee.value,
  //     appraisalDate: formData.appraisalDate.split("T")[0],
  //     status: formData.status,
  //     ratings: formData.ratings,
  //     createdBy: user.UserId,
  //   };

  //   if (selectedRow) {
  //     // Update Mode
  //     let Appraisal = selectedRow.Id;
  //     dispatch(updateAppraisal({ Appraisal, data: formattedData })).then(
  //       (res) => {
  //         if (res.meta.requestStatus === "fulfilled") {
  //           alert("Appraisal updated successfully!");
  //           window.location.reload();
  //         } else {
  //           alert("Failed to update appraisal.");
  //         }
  //       }
  //     );
  //   } else {
  //     // Create Mode
  //     dispatch(createappraisal(formattedData)).then((res) => {
  //       if (res.meta.requestStatus === "fulfilled") {
  //         alert("Appraisal added successfully!");
  //         window.location.reload();
  //       } else {
  //         alert("Failed to add appraisal.");
  //       }
  //     });
  //   }
  // };
  

  return (
    <div className="modal fade" id="add_performance_appraisal">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {" "}
              {edit ? "Update Appraisal" : "Add Appraisal"}
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Employee</label>
                    <Select
                      name="employee"
                      options={employees.map((emp: any) => ({
                        value: emp.EmployeeID,
                        label: emp.Name,
                      
                      }))}
                      onChange={handleEmployeeChange}
                      value={formData.employee}
                      required
                    />
                    
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Appraisal Date</label>
                    <DatePicker
                      className="form-control"
                      selected={formData.appraisalDate}
                      dateFormat="yyyy-MM-dd"
                      onChange={(date) =>
                        handleInputChange("appraisalDate", date)
                      }
                      placeholderText="YYYY-MM-DD"
                    />
                  </div>
                </div>
                {/* <div className="mb-3">
                  <label className="form-label">Role</label>
                  <Select options={roleindicator.map((group: any) => ({ value: group.Id, label: group.Name }))} />
                </div> */}

                {tabs.length > 0 && (
                  <ul className="nav nav-tabs">
                    {tabs.map((tab: any) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          type="button"
                          className={`nav-link ${
                            activeTab === tab.id ? "active" : ""
                          }`}
                          onClick={() => handleTabChange(tab.id)}
                        >
                          {tab.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}

                {tabs.map(
                  (tab: any) =>
                    activeTab === tab.id && (
                      <div className="card mt-3" key={tab.id}>
                        <div className="card-header">
                          <h5>{tab.name} Group</h5>
                        </div>
                        <div className="card-body">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Indicator</th>
                                <th>Expected Rating</th>
                                <th>Set Rating</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tab.indicators.map((indicator: any) => (
                                <tr key={indicator.indicator_id}>
                                  <td>{indicator.indicator_name}</td>
                                  <td>
                                    {indicator.ratings
                                      .map((rating: any) => rating.rating_name)
                                      .join(" / ") || "N/A"}
                                  </td>
                                  <td>
                                    <Select
                                      options={rating.map((r: any) => ({
                                        value: r.Id,
                                        label: r.Name,
                                      }))}
                                      onChange={(selectedOption: any) =>
                                        handleRatingChange(
                                          tab.id,
                                          indicator.indicator_id,
                                          selectedOption
                                        )
                                      }
                                      value={
                                        formData.ratings[tab.id]?.[
                                          indicator.indicator_id
                                        ]
                                          ? {
                                              value:
                                                formData.ratings[tab.id][
                                                  indicator.indicator_id
                                                ].ratingId,
                                              label:
                                                formData.ratings[tab.id][
                                                  indicator.indicator_id
                                                ].ratingName,
                                            }
                                          : null
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <Select
                    options={statusOptions}
                    value={statusOptions.find(
                      (option) => option.value === formData.status
                    )}
                    onChange={(selectedOption: any) =>
                      handleStatusChange(selectedOption?.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                {edit ? "Update Appraisal" : "Add Appraisal"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PerformanceAppraisalModal;
